import { APP_INITIALIZER, inject } from '@angular/core';
import { ABP, RoutesService } from '@abp/ng.core';
import { TERMINAL_PAYMENT_BASE_ROUTES } from './terminal-payment-base.routes';

export const TERMINAL_PAYMENTS_TERMINAL_PAYMENT_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);

  return () => {
    const routes: ABP.Route[] = [...TERMINAL_PAYMENT_BASE_ROUTES];
    routesService.add(routes);
  };
}
